module.exports = __webpack_public_path__ + "img/yw3.99aea8f3.png";